import {connect, IConnectProps} from 'globx-react';
import * as React               from 'react';

import StoreName        from '../../../../State/Shared/Constants/StoreName';
import IPlayerStores    from '../../../../State/Shared/Interfaces/IPlayerStores';
import Captions         from '../../../../State/Stores/Captions/Captions';
import * as TestIds     from '../../../Shared/Constants/TestIds';
import composeTokenList from '../../Util/composeTokenList';
import renderTestId     from '../../Util/renderTestId';

import mapCueSizeToClassName from './Util/mapCueSizeToClassName';
import serialiseActiveCues   from './Util/serialiseActiveCues';

import * as styles from './textTrack.css';

@connect(StoreName.CAPTIONS)
class TextTrack extends React.Component<IConnectProps<Captions, IPlayerStores>> {
    public shouldComponentUpdate(nextProps: IConnectProps<Captions>): boolean {
        const {value} = this.props;
        const nextValue = nextProps.value;

        return (
            value.activeCues.length !== nextValue.activeCues.length ||
            (
                value.activeCues.length > 0 &&
                serialiseActiveCues(value.activeCues) !== serialiseActiveCues(nextValue.activeCues)
            ) ||
            value.frame.areControlsActive !== nextValue.frame.areControlsActive
        );
    }

    public render(): JSX.Element {
        const {value, stores} = this.props;
        const {config} = stores;
        const captionsConfig = config.value.captions;

        if (!captionsConfig.enable) return null;

        const textTrackclassName = composeTokenList([
            styles.textTrack,
            [!value.frame.areControlsIdle, styles.textTrackFloating]
        ]);

        const cueClassName = composeTokenList([
            styles.cue,
            mapCueSizeToClassName(captionsConfig.cueSize)
        ]);

        return (
            <div className={textTrackclassName}>
                {value.activeCues.map(cue =>
                    <span
                        data-test-id={renderTestId(TestIds.PLAYER_CUE)}
                        className={cueClassName}
                        key={cue.id}
                        dangerouslySetInnerHTML={({__html: cue.text})}>
                    </span>
                )}
            </div>
        );
    }
}

export default TextTrack;